import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  padding: 32px;
`;

export const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background: #fee;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Icon = styled.span`
  font-size: 3rem;
`;

export const Title = styled.h2`
  font-size: 1.75rem;
  font-weight: 900;
  color: #dc2626;
  margin: 0 0 16px 0;
  text-transform: uppercase;
`;

export const Message = styled.p`
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  margin: 0 0 12px 0;
`;

export const Subtitle = styled.p`
  font-size: 1.15rem;
  color: var(--primary, #f58220);
  font-weight: 700;
  margin: 0 0 32px 0;
`;

export const CloseButton = styled.button`
  width: 100%;
  background: var(--primary, #f58220);
  color: white;
  font-weight: 900;
  font-size:1rem;
  padding: 16px 32px;
  border-radius: 16px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: uppercase;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(245, 130, 32, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;
